<template>
  <div class="hello">
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      test: []
    }
  },
  mounted(){
    let vobj=this;
    this.axios.get(`${process.env.ExternalApi}/api/ExternalControllers/Committee/GetCommitteeNewsList`,{
        headers:{
          Authorization: Token,
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET'
          }
    }).then((response) => {
        if(response.status == 200){
           
            console.log(response);
           
        }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/page1.vue